import batchCalcWidth from '../utils/mapLabelsUtils';
import { TextType, MapLabelText, MapLabelTextPath } from '../__types';

const region: TextType = {
  fill: '#aeaeae',
  fontFamily: 'ringbearermedium',
  fontSize: 180,
};

const locationBig: TextType = {
  fill: '#676767',
  fontFamily: 'anironregular',
  fontSize: 40,
};

const locationSmall: TextType = {
  fill: '#676767',
  fontFamily: 'anironregular',
  fontSize: 20,
};

const river: TextType = {
  fill: '#676767',
  fontFamily: 'anironregular',
  fontSize: 30,
};

const otherBig: TextType = {
  fill: '#676767',
  fontFamily: 'anironregular',
  fontSize: 60,
};

const otherSmall: TextType = {
  fill: '#676767',
  fontFamily: 'anironregular',
  fontSize: 30,
};

const mapLabels: {
  ['text']: MapLabelText[];
  ['textPath']: MapLabelTextPath[];
} = {
  text: [
    {
      id: 'bree',
      text: 'Bree',
      x: 2350,
      y: 1400,
      textType: locationBig,
      coords: { x: 2260, y: 1350 },
    },
    {
      id: 'hobbiton',
      text: 'Hobbiton',
      x: 1910,
      y: 1400,
      rotation: 45,
      textType: locationBig,
      coords: { x: 1836, y: 1323 },
    },
    {
      id: 'erebor',
      text: 'Erebor',
      x: 4500,
      y: 850,
      textType: locationBig,
      coords: { x: 4360, y: 864 },
    },
    {
      id: 'brandywineBridge',
      text: 'Brandywine\n  Bridge',
      x: 2060,
      y: 1290,
      rotation: 330,
      textType: locationSmall,
      coords: { x: 1996, y: 1294 },
    },
    {
      id: 'oldForest',
      text: '  Old\nForest',
      x: 2140,
      y: 1340,
      textType: otherSmall,
      coords: { x: 2283, y: 1386 },
    },
    {
      id: 'lastBridge',
      text: 'Last\nBridge',
      x: 2980,
      y: 1350,
      rotation: 15,
      textType: locationSmall,
      coords: { x: 2890, y: 1280 },
    },
    {
      id: 'rivendell',
      text: 'Rivendell',
      x: 3350,
      y: 1310,
      rotation: 3,
      textType: locationBig,
      coords: { x: 3228, y: 1288 },
    },
    {
      id: 'moriaGate',
      text: 'Moria\n Gate',
      x: 2990,
      y: 1880,
      rotation: -15,
      textType: locationBig,
      coords: { x: 3127, y: 1854 },
    },
    {
      id: 'lorien',
      text: 'Lórien',
      x: 3450,
      y: 2120,
      rotation: 15,
      textType: otherSmall,
      coords: { x: 3445, y: 2020 },
    },
    {
      id: 'isengard',
      text: 'Isengard',
      x: 2750,
      y: 2550,
      textType: locationBig,
      coords: { x: 2949, y: 2545 },
    },
    {
      id: 'esgaroth',
      text: 'Esgaroth',
      x: 4500,
      y: 1000,
      textType: locationBig,
      coords: { x: 4363, y: 987 },
    },
    {
      id: 'deadMarshes',
      text: '  Dead\nMarshes',
      x: 4280,
      y: 2780,
      rotation: 30,
      textType: otherSmall,
      coords: { x: 4200, y: 2872 },
    },
    {
      id: 'minasMorgul',
      text: 'Minas\nMorgul',
      x: 4470,
      y: 3350,
      textType: locationSmall,
      coords: { x: 4339, y: 3283 },
    },
    {
      id: 'minasTirith',
      text: 'Minas\nTirith',
      x: 4240,
      y: 3290,
      rotation: 30,
      textType: locationSmall,
      coords: { x: 4230, y: 3290 },
    },
    {
      id: 'baradDur',
      text: 'Barad-Dûr',
      x: 4870,
      y: 3230,
      textType: locationBig,
      coords: { x: 4767, y: 3126 },
    },
    {
      id: 'ironHills',
      text: 'IRON HILLS',
      x: 4940,
      y: 780,
      textType: otherBig,
      coords: { x: 5170, y: 921 },
    },
    {
      id: 'udun',
      text: 'Udûn',
      x: 4510,
      y: 3020,
      textType: otherSmall,
      coords: { x: 4450, y: 2955 },
    },
    {
      id: 'drimrillDale',
      text: 'Drimrill Dale',
      x: 3420,
      y: 1950,
      rotation: -30,
      textType: locationBig,
      coords: { x: 3244, y: 1828 },
    },
    {
      id: 'seaOfRhun',
      text: 'Sea of\nRhûn',
      x: 5400,
      y: 1900,
      textType: otherBig,
      coords: { x: 5760, y: 2026 },
    },
    {
      id: 'rohan',
      text: 'r o h a n',
      x: 3120,
      y: 2720,
      rotation: -15,
      textType: region,
      coords: { x: 3445, y: 2631 },
    },
    {
      id: 'gondor',
      text: 'g o n d o r',
      x: 3060,
      y: 3200,
      rotation: 20,
      textType: region,
      coords: { x: 3325, y: 3390 },
    },
    {
      id: 'dolGuldur',
      text: 'Dol\nGuldur',
      x: 4030,
      y: 2010,
      textType: locationSmall,
      coords: { x: 3868, y: 1968 },
    },
    {
      id: 'eastBight',
      text: 'East\nBight',
      x: 4330,
      y: 1730,
      textType: otherSmall,
      coords: { x: 4294, y: 1708 },
    },
    {
      id: 'fangorn',
      text: 'Fangorn',
      x: 3230,
      y: 2620,
      rotation: -5,
      textType: otherSmall,
      coords: { x: 3294, y: 2382 },
    },
    {
      id: 'farDowns',
      text: '  Far\nDowns',
      x: 1700,
      y: 1460,
      textType: otherSmall,
      coords: { x: 1615, y: 1383 },
    },
    {
      id: 'weatherHills',
      text: 'Weather\n  Hills',
      x: 2530,
      y: 1080,
      rotation: 35,
      textType: otherSmall,
      coords: { x: 2500, y: 1164 },
    },
    {
      id: 'weathertop',
      text: 'Weathertop',
      x: 2660,
      y: 1320,
      rotation: -15,
      textType: otherSmall,
      coords: { x: 2553, y: 1293 },
    },
    {
      id: 'oldForestRoad',
      text: 'Old Forest Road',
      x: 3990,
      y: 1280,
      rotation: -2,
      textType: otherSmall,
      coords: { x: 4062, y: 1218 },
    },
  ],
  textPath: [
    {
      id: 'mordor',
      text: 'm o r d o r',
      x: 0,
      y: 100,
      data: `M 4905.00,3477.00
      C 5373.00,3450.00 5505.00,3372.00 5754.00,3192.00`,
      textType: region,
      coords: { x: 5205, y: 3400 },
    },
    {
      id: 'shire',
      text: 'S H I R E',
      x: 1640,
      y: 1330,
      data: 'M 0 0 C 0 0 300 0 400 -200',
      textType: otherBig,
      coords: { x: 1765, y: 1220 },
    },
    {
      id: 'brandywine',
      text: 'B r a n d y w i n e',
      x: 80,
      y: 30,
      data: `M 1842.00,1915.00
      C 1856.00,1854.00 1844.00,1840.00 1871.00,1813.00
        1898.00,1786.00 1947.00,1758.00 1962.00,1750.00
        1977.00,1742.00 2089.00,1672.00 2127.00,1630.00`,
      textType: river,
      coords: { x: 1816, y: 1891 },
    },
    {
      id: 'trollshaws',
      text: 'T r o l l s h a w s',
      x: 3000,
      y: 1260,
      data: 'M 0 0 C 50 -20 200 -50 300 50',
      textType: otherSmall,
      coords: { x: 3051, y: 1266 },
    },
    {
      id: 'mitheithel',
      text: 'M i t h e i t h e l',
      x: 70,
      y: 30,
      data: `M 2605.00,1733.00
      C 2605.00,1733.00 2781.00,1666.00 2801.00,1612.00
        2821.00,1558.00 2837.00,1372.00 2835.00,1312.00`,
      textType: river,
      coords: { x: 2862, y: 1515 },
    },
    {
      id: 'emynMuil',
      text: 'E m y n  M u i l',
      x: 90,
      y: 80,
      data: `M 3895.00,2736.00
      C 3895.00,2736.00 3939.00,2647.00 3982.00,2613.00
        4025.00,2579.00 4114.00,2543.00 4232.00,2553.00`,
      textType: otherSmall,
      coords: { x: 4002, y: 2694 },
    },
    {
      id: 'orodruin',
      text: 'O r o d r u i n',
      x: 110,
      y: 80,
      data: `M 4508.00,3159.00
      C 4508.00,3159.00 4572.00,3214.00 4617.00,3212.00
        4662.00,3210.00 4704.00,3184.00 4728.00,3162.00`,
      textType: locationSmall,
      coords: { x: 4614, y: 3154 },
    },
    {
      id: 'morannon',
      text: 'M o r a n n o n',
      x: 100,
      y: 60,
      data: `M 4401.00,2871.00
      C 4539.00,2808.00 4563.00,2793.00 4737.00,2859.00`,
      textType: locationSmall,
      coords: { x: 4407, y: 2877 },
    },
    {
      id: 'mirkwood',
      text: 'M i r k w o o d',
      x: 100,
      y: 60,
      data: `M 4272.00,2106.00
      C 4413.00,1998.00 4494.00,1923.00 4467.00,1752.00
        4440.00,1581.00 4404.00,1569.00 4416.00,1464.00
        4428.00,1359.00 4446.00,1272.00 4443.00,1182.00`,
      textType: otherBig,
      coords: { x: 4044, y: 1480 },
    },
    {
      id: 'rhun',
      text: 'r h û n',
      x: 200,
      y: 100,
      data: `M 5886.00,477.00
      C 6147.00,957.00 6348.00,1251.00 6126.00,2121.00`,
      textType: region,
      coords: { x: 6103, y: 1164 },
    },
    {
      id: 'rhovanion',
      text: 'r h o v a n i o n',
      x: 100,
      y: 100,
      data: `M 4209.00,2409.00
      C 4545.00,2136.00 4635.00,1893.00 4671.00,1770.00
        4707.00,1647.00 4776.00,1176.00 4776.00,966.00`,
      textType: region,
      coords: { x: 4689, y: 2032 },
    },
    {
      id: 'arnor',
      text: 'a r n o r',
      x: 150,
      y: -200,
      data: `M 1281.00,942.00
      C 1611.00,774.00 1857.00,669.00 2043.00,717.00
        2277.00,732.00 2676.00,1005.00 2865.00,1110.00`,
      textType: region,
      coords: { x: 2643, y: 840 },
    },
    {
      id: 'forodwaith',
      text: 'f o r o d w a i t h',
      x: 100,
      y: 100,
      data: `M 3003.00,234.00
      C 3465.00,354.00 3720.00,417.00 3948.00,417.00
        4176.00,417.00 4656.00,348.00 4656.00,348.00`,
      textType: region,
      coords: { x: 3646, y: 380 },
    },
    {
      id: 'eriador',
      text: 'e r i a d o r',
      x: 100,
      y: 300,
      data: `M 1350.00,906.00
      C 1566.00,1236.00 1692.00,1476.00 2004.00,1602.00
        2316.00,1728.00 2619.00,1653.00 2973.00,1440.00`,
      textType: region,
      coords: { x: 2919, y: 1701 },
    },
    {
      id: 'anduin',
      text: 'A n d u i n',
      x: 100,
      y: 40,
      data: `M 3598.50,2046.00
      C 3624.00,1959.00 3640.50,1894.50 3717.00,1807.50`,
      textType: river,
      coords: { x: 3687, y: 1776 },
    },
  ],
};

batchCalcWidth(mapLabels.text);

export default mapLabels;
